module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl2_m.8adf9a3b71071e3a9f4d5eb71ca8db54.png";